import * as React from 'react';

export class Input extends React.Component<{
    value: string;
    onBlur: (value: string) => void;
    className: string;
}, {
    editing: boolean;
    value: string;
}> {
    state = { editing: false, value: "" };

    render() {
        const value = this.state.editing ? this.state.value : this.props.value;
        return <input
            onKeyDown={p => this.handleKeyDown(p.keyCode)}
            className={this.props.className}
            value={value || ""}
            onFocus={() => this.setState({ editing: true, value: this.props.value })}
            onBlur={() => { this.setState({ editing: false }); this.props.onBlur(this.state.value) }}
            onChange={p => this.setState({ value: p.target.value })} />;
    }

    handleKeyDown(keyCode: number) {
        if (keyCode === 13) {
            this.props.onBlur(this.state.value);
        } else if (keyCode === 27) {
            this.setState({ value: this.props.value });
        }
    }
}
